import React from "react"
import { css, useTheme } from "@emotion/react"
import { StyledCheckbox } from "./StyledCheckbox"
import { BodyTextRegular } from "../../typography/text"

type Props = {
  label?: string
  innerRef?: any
  innerText?: string
  labelLink?: React.ReactNode
  wrapperWidth?: string
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >

export const CheckboxField = ({
  label,
  innerRef,
  labelLink,
  disabled,
  innerText,
  wrapperWidth,
  ...rest
}: Props) => {
  const theme = useTheme()

  const checkboxStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    margin-bottom: 0px;
    cursor: pointer;
    &:hover {
      > div > .customElement {
        background-color: ${theme.colors.whiteHover};
      }
      > div > input:checked ~ .customElement {
        background-color: ${theme.colors.ctaMain};
      }
    }
    width: ${wrapperWidth || "fit-content"};
  `

  const labelStyle = css`
    cursor: ${disabled ? "default" : "pointer"};
  `

  return (
    <label css={checkboxStyle}>
      <StyledCheckbox
        innerText={innerText}
        disabled={disabled}
        innerRef={innerRef}
        {...rest}
      />
      {label && (
        <BodyTextRegular
          color={disabled ? theme.colors.secondary2 : theme.colors.primary}
          css={labelStyle}
        >
          {label} {labelLink}
        </BodyTextRegular>
      )}
    </label>
  )
}
